import React from "react";
import { FormattedMessage } from "react-intl";

import { HStack, Text } from "@/components/ui";

interface TombstoneProps {
  id: string;
  type?: "muted" | "blocking" | "blocked_by" | "deleted";
  contextType?: string;
  action?: React.ReactElement;
}

/** Represents a deleted item. */
const Tombstone: React.FC<TombstoneProps> = ({
  action,
  contextType,
  id,
  type = "deleted",
}) => {
  const renderText = () => {
    switch (type) {
      case "deleted":
        return (
          <FormattedMessage
            id="statuses.tombstone"
            defaultMessage="This Truth is unavailable."
          />
        );
      case "muted":
        return (
          <FormattedMessage
            id="status.tombstone.muted"
            defaultMessage="This Truth is from an account you muted."
          />
        );
      case "blocking":
        return (
          <FormattedMessage
            id="status.tombstone.blocked"
            defaultMessage="This Truth is from an account you blocked."
          />
        );
      case "blocked_by":
        return (
          <FormattedMessage
            id="status.tombstone.blocked_by"
            defaultMessage="You’re unable to view this Truth because this account limits who can view their content."
          />
        );
      default:
        return (
          <FormattedMessage
            id="status.tombstone.unavailable"
            defaultMessage="This Truth is unavailable."
          />
        );
    }
  };

  return (
    <div className={contextType === "thread" ? "h-16" : ""}>
      <HStack
        className="focusable rounded-lg border-2 border-gray-200 p-4 focus:outline-1 focus:outline-primary-300 dark:border-gray-800"
        alignItems="center"
        justifyContent={action ? "between" : "around"}
        space={4}
      >
        <Text theme="muted">{renderText()}</Text>

        {action}
      </HStack>
    </div>
  );
};

export default Tombstone;
